import { useNavigate } from "react-router-dom";
import { PROFILE_PERSONAL_DATA_VIEW_PATH } from "../../../../../constants/env";
import { useNavigateBackOrToPath } from "../../../../hooks/use-navigate-back-or-to-path/use-navigate-back-or-to-path";
import { useModal } from "../../../../hooks/useDialog";
import { BonusXThemeProvider } from "../../../../theme/BonusXThemeProvider";
import { TwoButtonsWarningModalContent } from "../two-buttons-warning-modal/two-buttons-warning-modal-content";

const CONFIRM_EDIT_PERSONAL_DATA_MODAL_ID = "confirm-edit-personal-data-modal";
const CONFIRM_EDIT_PERSONAL_DATA_MODAL_EXIT_BUTTON_ID = `${CONFIRM_EDIT_PERSONAL_DATA_MODAL_ID}-exit-button-id`;
const CONFIRM_EDIT_PERSONAL_DATA_MODAL_CONTINUE_EDIT_BUTTON_ID = `${CONFIRM_EDIT_PERSONAL_DATA_MODAL_ID}-continue-edit-button-id`;

const EXIT_BUTTON_TEXT = "Esci";
const CONTINUE_EDIT_BUTTON_TEXT = "Continua a modificare";

const CHANGES_NOT_SAVED_TITLE = "Modifiche non salvate";
const EXIT_FROM_PAGE_WARNING_TEXT = "Attenzione, se esci perderai le tue modifiche";

export interface IConfirmExitContentProps {
  onExit?: () => void;
}
export function ConfirmExitContent({ onExit }: Readonly<IConfirmExitContentProps>): JSX.Element {
  const { close } = useModal();
  const navigate = useNavigate();
  const { navigateBackOrToPath } = useNavigateBackOrToPath({ navigate });

  function handleOnExitButtonClick() {
    close();
    if (onExit) {
      onExit();
      return;
    }
    navigateBackOrToPath(PROFILE_PERSONAL_DATA_VIEW_PATH);
  }

  function handleOnContinueEditButtonClick() {
    close();
  }

  return (
    <BonusXThemeProvider>
      <TwoButtonsWarningModalContent
        title={CHANGES_NOT_SAVED_TITLE}
        subtitle={EXIT_FROM_PAGE_WARNING_TEXT}
        firstButtonId={CONFIRM_EDIT_PERSONAL_DATA_MODAL_EXIT_BUTTON_ID}
        firstButtonText={EXIT_BUTTON_TEXT}
        firstButtonVariant="outlined"
        firstButtonColor="primary"
        secondButtonId={CONFIRM_EDIT_PERSONAL_DATA_MODAL_CONTINUE_EDIT_BUTTON_ID}
        secondButtonText={CONTINUE_EDIT_BUTTON_TEXT}
        secondButtonVariant="contained"
        secondButtonColor="primary"
        firstButtonClick={handleOnExitButtonClick}
        secondButtonClick={handleOnContinueEditButtonClick}
      />
    </BonusXThemeProvider>
  );
}
